import { Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

const BigTitle = ({ children }: { children: ReactNode }) => (
    <Text color="gray.900" fontSize="24px" fontWeight={700} lineHeight={1} letterSpacing="-0.48px">
        {children}
    </Text>
);

export default BigTitle;
